import { GET_RANKS, POST_SUSCRIBE_RANKS } from "constants/api";
import { useHistory } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import axios, { AxiosError } from "axios";
import { useSession } from "../../../contexts/session-context";
import { LoaderContext } from "../../../contexts/loader-context";
import { TrRank } from '../../../theme/theme'
import RankingPosition from "./RankingPosition";

interface IProps {
  version: string
}

export default function RankingActive({ version }: IProps) {
  const history = useHistory()
  const [{ data: session }] = useSession()
  const { setLoad } = useContext(LoaderContext)
  const [ranking, setRanking] = useState(null)

  const postSuscribe = async () => {
    try {
      await axios.post(POST_SUSCRIBE_RANKS, undefined, {
        headers: { Authorization: `Bearer ${((session as any)?._tokenResponse as any)?.idToken}` }
      })

      location.reload()
    } catch (error) {
      const err = error as AxiosError
      if (err?.response.data?.code) {
        return history.push(`/error/${err.response?.data.code}`)
      }
    }
  }

  const fetchRank = async () => {
    setLoad(true)
    try {
      const codeResponse = await axios.get(GET_RANKS, {
        headers: { Authorization: `Bearer ${((session as any)?._tokenResponse as any)?.idToken}` }
      })
      setRanking(codeResponse.data)
    } catch (error) {
      const err = error as AxiosError

      if (err.response?.data.code !== 711 && err.response?.data.code) {
        return history.push(`/error/${err.response?.data.code}`)
      }

      if (version !== 'v2') {
        return history.push('/ranking/suscribe')
      }

      await postSuscribe()
    } finally {
      setLoad(false)
    }
  }

  useEffect(() => {
    if (session) {
      fetchRank()
    }
  }, [])

  return (
    <div className="flex flex-col h-full">
      <RankingPosition ranking={ranking} />
      <section className="flex-grow flex-1 overflow-y-auto px-4">
        {ranking ?
          ranking.rankWinners?.length
            ? ranking.rankWinners.filter(winner => winner.points !== 0).map((item: any, index: number) => {
              return (
                <TrRank key={index} className="din font-black text-base w-full flex items-center justify-between mb-3 card" index={index}>
                  <div className='flex items-center gap-6 user'>
                    <h5>{item?.id}.</h5>
                    <h5>{item?.profileId ? `ID: ${item?.profileId}` : 'Anónimo'}</h5>
                  </div>
                  <div className='quantity'>
                    <p>{item?.points}</p> <span>{POINTS_NAME}</span>
                  </div>
                </TrRank>
              )
            })
            : (
              <p className='rank-blank'>Aún no hay participantes, verás las posiciones aquí cuando se active.</p>
            )
          : (
            <p className='rank-blank'>Aún no hay participantes, verás las posiciones aquí cuando se active.</p>
          )
        }
      </section>
    </div>
  )
}